import React, { useState } from 'react';
import InboxTableBody from './InboxTableBody';
import { Table } from 'react-bootstrap';
import classes from './index.module.scss';
import { messageDelete } from '../../api';
import { deleteMessageNotice } from '../../components/UI/Notifications';
import Modal from '../UI/Modal';
import { useForm } from 'react-hook-form';

const InboxTable = ({ messageData, setLoading, triggerSearch, setTriggerSearch, handleDefaultStatusCodes, trigger, setTrigger }) => {
  const [show, setShow] = useState(false);
  const { handleSubmit } = useForm();
  const [messageId, setMessageId] = useState(null);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const deleteMessage = id => {
    setMessageId(id)
    handleShow();    
  }

  const onSubmit = () => {
    setLoading(true);
    messageDelete({message_id: messageId})
      .then(response => {
        handleClose();
        setTriggerSearch(!triggerSearch);
        setTrigger(!trigger);
        deleteMessageNotice();
        setLoading(false);
      })
      .catch(error => {
        handleDefaultStatusCodes(error.response.status);
        handleClose();
      })
  }

  return (
    <>
      <Table striped responsive className={classes.Table}>
        <tbody className={classes.Table_Body}>
          <InboxTableBody 
            list={messageData}
            deleteMessage={deleteMessage}
          /> 
        </tbody>
      </Table>
      <Modal 
        handleClose={handleClose} 
        show={show}
        handleSubmit={handleSubmit}
        onSubmit={onSubmit}
        buttonLabel="Delete"
      >
        <h5 className="mb-4">Are you sure you want to delete this message?</h5>
      </Modal>
    </>
  )
}

export default InboxTable;